import React from 'react';
import { translateRaw } from './globalTranslator';

if (!React.__LOGIFLOW_I18N_PATCHED__) {
  const originalCreateElement = React.createElement;
  // Legacy fallback for untranslated literals.
  // Prefer explicit translation calls and phase this out over time.

  const shouldSkipTranslation = (value) => {
    if (typeof value !== 'string') return true;
    if (!value.trim()) return true;
    if (/^https?:\/\//i.test(value)) return true;
    return false;
  };

  const translateChild = (child) => {
    if (typeof child === 'string') {
      if (shouldSkipTranslation(child)) return child;
      return translateRaw(child);
    }
    if (Array.isArray(child)) {
      return child.map((nested) => translateChild(nested));
    }
    return child;
  };

  const translateProps = (props) => {
    if (!props) return props;
    const keysToTranslate = new Set([
      'aria-label',
      'ariaLabel',
      'placeholder',
      'title',
      'helperText',
      'label',
      'tooltip',
      'tooltipLabel',
    ]);
    let updated = null;
    Object.entries(props).forEach(([key, value]) => {
      if (
        typeof value === 'string' &&
        !shouldSkipTranslation(value) &&
        keysToTranslate.has(key)
      ) {
        if (!updated) {
          updated = { ...props };
        }
        updated[key] = translateRaw(value);
      }
    });
    return updated || props;
  };

  React.createElement = function patchedCreateElement(type, props, ...children) {
    // Only auto-translate intrinsic DOM elements.
    // Custom components should translate internally.
    if (typeof type !== 'string') {
      return originalCreateElement(type, props, ...children);
    }

    if (!children || children.length === 0) {
      const translatedProps = translateProps(props);
      return originalCreateElement(type, translatedProps, ...children);
    }
    const nextChildren = children.map((child) => translateChild(child));
    const translatedProps = translateProps(props);
    return originalCreateElement(type, translatedProps, ...nextChildren);
  };

  Object.defineProperty(React, '__LOGIFLOW_I18N_PATCHED__', {
    value: true,
    configurable: false,
    enumerable: false,
    writable: false,
  });
}
